import { TranslatePipe } from '../../../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../../../components/loader-overlay/loader-overlay.component';
import { InputAutocompleteComponent } from '../../../../components/input-autocomplete/input-autocomplete.component';
import { ItemErrorComponent } from '../../../../components/item-form-error/item-form-error.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Config from '../../../../utils/config.service';
import RestService from '../../../../services/core-rest.service';
import PreVisitRecordTicketForPersonService from '../../../../services/pre-visit-record-ticket-for-person.service';
import AngularHelperService from '../../../../services/angular-helper.service';
import AngularFilterHelperService from '../../../../services/angular-filter-helper.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	standalone: true,
	selector: 'modal-update-user',
	templateUrl: './modal-update-user.component.html',
	imports: [ CommonModule, TranslatePipe, LoaderOverlayComponent, InputAutocompleteComponent, ItemErrorComponent, FormsModule ]
})
export class ModalUpdateUserComponent implements OnInit {
	private config: Config = inject(Config);
	private restService: RestService = inject(RestService);
	private preVisitRecordTicketForPersonService: PreVisitRecordTicketForPersonService = inject(PreVisitRecordTicketForPersonService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private dialogRef = inject(MatDialogRef<ModalUpdateUserComponent>);
	private data = inject(MAT_DIALOG_DATA);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);
		
		this.vm.processing = false;
		
		this.handleModalInit();
		
		this.vm.handleModalClose = this.handleModalClose;
		this.vm.handleModalSubmit = this.handleModalSubmit;
		this.vm.handleCountryCodeSearch = this.handleCountryCodeSearch;
		this.vm.handleCountryCodeSelect = this.handleCountryCodeSelect;
		this.vm.clearCountryCodeSearch = this.clearCountryCodeSearch;
	}
	
	handleModalInit() {
		this.vm.user = this.preVisitRecordTicketForPersonService.getPatient().user;
		if (this.vm.user.personalCode !== this.vm.userEstonianIdentificationCode) {
			this.dialogRef.close();
		}
		if (this.vm.user.phone && this.vm.user.phone.startsWith(this.vm.user.countryCode)) {
			this.vm.user.phone = this.vm.user.phone.replace(this.vm.user.countryCode, '');
		}
		
		this.vm.countryPhoneCodes = this.config.getSettings().CountryPhoneCodes;
		if (this.vm.user.countryCode) {
			this.vm.countryCode = this.vm.countryPhoneCodes.filter((item) => { return item.dialCode === this.vm.user.countryCode })[0];
		} else {
			this.vm.countryCode = this.vm.countryPhoneCodes.filter((item) => { return item.countryCode === 'EE' })[0];
		}
	}
	
	handleModalSubmit(mainForm: any) {
		this.vm.submitted = true;
		if (mainForm.invalid || !this.vm.countryCode) {
			return;
		}
		if (this.vm.processing) {
			return;
		}
		
		var countryCode: any = (this.vm.countryCode.dialCode || '');
		var processedNumber: any = (!this.vm.user.phone || '-' === this.vm.user.phone)
			? '-' : ((this.vm.user.phone || '').match(/\d/g)).join('');
		this.vm.user.countryCode = countryCode;
		this.vm.user.phone = ('-' === processedNumber)
			? '-'
			: countryCode + (processedNumber && processedNumber.length > 0 ? processedNumber : '-');
		
		this.vm.processing = true;
		this.restService.savePreVisitRecordForPatientUpdateUser(this.vm.user).then(
			(response) => {
				this.preVisitRecordTicketForPersonService.updatePatientUser(response);
				this.dialogRef.close(response)
			},
			(error) => {
				this.vm.user.phone = processedNumber;
				if (error.error.errorCode === 'INSURANCE_INFO_NOT_FOUND') {
					alert(this.angularFilterHelperService.translate('PreVisit.Record_Ticket_For_Person.Consents_Not_Given'));
				} else {
					alert(this.angularFilterHelperService.translate('Errors.Technical_Error'));
				}
				console.error('Failed creating user', error);
				this.vm.processing = false;
			}
		);
	}
	
	handleModalClose() {
		this.dialogRef.close();
	}
	
	handleCountryCodeSearch = (searchParams: any): void => {
		var namePart = searchParams.namePart;
		
		var countryCodes: any = this.vm.countryPhoneCodes.filter((item) => {
			return item.country.toLowerCase().indexOf(namePart.toLowerCase()) !== -1
				|| item.dialCode.toLowerCase().indexOf(namePart.toLowerCase()) !== -1
				|| item.countryCode.toLowerCase().indexOf(namePart.toLowerCase()) !== -1;
		});
		
		var deferred: any = this.angularHelperService.getDeferredPromise();
		deferred.resolve(countryCodes.slice(0, countryCodes.length < 10 ? countryCodes.length : 10));
		return deferred.promise;
	}
	
	handleCountryCodeSelect = (selectedCountryCode: any): void => {
		this.vm.countryCode = this.angularHelperService.copy(selectedCountryCode.selectedItem);
		this.vm.countryCode.name = this.vm.countryCode.dialCode;
	}
	
	clearCountryCodeSearch = () => {
		this.vm.countryCode = undefined;
	}
	
}